import styled, { css } from 'styled-components';

import AppearanceWrapper from '../../../_common/Controller/components/AppearanceWrapper/AppearanceWrapper';
import ControllerWrapper from '../../../_common/Controller/components/ControllerWrapper/ControllerWrapper';

import { dropdownTokens } from '../../../../tokens/components/Dropdown/tokens';

/* @internal */
export const DropdownAura = styled.li`
  font-size: ${dropdownTokens.ItemFontSizeBaseDefault};

  ${({ theme }) =>
    theme.sticky &&
    css`
      background-color: ${dropdownTokens.ItemBackgroundColorBaseDefault};
      position: sticky;
      top: -6px;
      z-index: 1;
    `}

  // Removed top padding from Checkboxes and Radios
  ${AppearanceWrapper} {
    padding-top: 0;
    width: auto;
  }

  ${ControllerWrapper} {
    width: auto;
  }
`;

export default DropdownAura;
